import { createSlice } from '@reduxjs/toolkit';
import { getAccountById, login } from './accountThunks';
import { PURGE } from 'redux-persist';
import { STORAGE } from '../../../constants';
import { setItemToLocalStorage } from '../../../services/network/storage';
import TokenService from '../../../services/network/tokenService';
import { setToken } from '../../../services/network/api';

const SLICE_NAME = 'account';

const initialState = {
    data: {},
    isLoading: false,
    error: null,
    accountDataLoading: false,
};

export const accountSlice = createSlice({
    name: SLICE_NAME,
    initialState,
    reducers: {
        clearAccountData(state) {
            state.data = {};
            state.isLoading = false;
            state.error = null;
            state.accountDataLoading = false;
        },
        setAccountDataLoading(state, action) {
            state.accountDataLoading = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountById.pending, (state) => {
                state.accountDataLoading = true;
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAccountById.fulfilled, (state, action) => {
                state.isLoading = false;
                state.error = null;
                state.data = action.payload.account;
                state.accountDataLoading = false;
            })
            .addCase(getAccountById.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.accountDataLoading = false;
            })
            .addCase(login.pending, (state) => {
                state.accountDataLoading = true;
                state.error = null;
            })
            .addCase(login.fulfilled, (state, action) => {
                const { accessToken, refreshToken, accountId } = action.payload;
                TokenService.storeAccessToken(accessToken);
                TokenService.storeRefreshToken(refreshToken);
                setItemToLocalStorage(STORAGE.ACCOUNT_ID, accountId);
                setToken(accessToken);
                state.accountDataLoading = false;
                state.error = null;
            })
            .addCase(login.rejected, (state, action) => {
                state.accountDataLoading = false;
                state.error = action.payload;
            })
            .addCase(PURGE, () => initialState);
    },
});

export const selectAccountData = (state) => state.account.data;
export const selectAuthError = (state) => state.account.error;
export const selectAccountLoading = (state) => state.account.isLoading;
export const selectCompanyType = (state) =>
    state.account.data.company?.typeCorporate ?? null;
export const selectAccountCompany = (state) =>
    state.account.data.company ?? null;
export const selectAccountPhone = (state) => state.account.data.phone ?? null;
export const selectAccountEmail = (state) => state.account.data.email ?? null;
export const selectAccountDataLoading = (state) =>
    state.account.accountDataLoading;
export const selectAccountId = (state) => state.account.data.id;
export const selectAccountType = (state) => state.account.data.accountType;

export const { clearAccountData, setAccountDataLoading } = accountSlice.actions;

export const accountReducer = accountSlice.reducer;
